import { ChangeDetectorRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loaderCounter: number = 0;
  private tableLoaderCounter: number = 0;
  private loading: boolean = false;
  private tableLoading: boolean = false;
  public errorType: string = '';
  private cdr?: ChangeDetectorRef;

  constructor() {}

  register(cdr: ChangeDetectorRef) {
    this.cdr = cdr;
  }

  set loadingState(state: boolean) {
    setTimeout(() => {
      if (state) {
        this.loading = true;
        this.loaderCounter += 1;
      } else {
        this.loaderCounter -= 1;
        if (this.loaderCounter <= 0 || this.errorType == 'invalid_grant') {
          this.loading = false;
          this.loaderCounter = 0;
        }
      }
    }, 500);
  }

  set tableLoadingState(state: boolean) {
    setTimeout(() => {
      if (state) {
        this.tableLoading = true;
        this.tableLoaderCounter += 1;
      } else {
        this.tableLoaderCounter -= 1;
        if (this.tableLoaderCounter <= 0 || this.errorType == 'invalid_grant') {
          this.tableLoading = false;
          this.cdr?.detectChanges();
          this.tableLoaderCounter = 0;
        }
      }
    }, 500);
  }

  forceStopLoading() {
    this.loading = false;
    this.loaderCounter = 0;
    this.tableLoading = false;
    this.tableLoaderCounter = 0;
  }

  get isLoading() {
    return this.loading;
  }

  get isTableLoading() {
    return this.tableLoading;
  }
}
